import useLazyData from '@/hooks/useLazyData';
import dynamic from 'next/dynamic';
import Skeleton from './skeleton';

const DynamicCouponContainer = dynamic(() => import('./coupon-container'), {
  ssr: false,
  loading: Skeleton
});

const MkplCouponContainer = props => {
  const { ref: viewRef, show } = useLazyData({
    threshold: 0.01,
    rootMargin: '10px 0px 0px 0px'
  });

  const skeleton = <Skeleton />;

  if (!show) {
    return <div ref={viewRef}>{skeleton}</div>;
  }

  return <DynamicCouponContainer skeleton={skeleton} {...props} />;
};

export default MkplCouponContainer;
